// Azure Speech Translation language codes mapped to the app's locale system
// Azure uses BCP-47 codes for speech recognition and short codes for translation targets
export const AZURE_SPEECH_LANGUAGES = {
    en_US: { speechCode: "en-US", translateCode: "en", displayName: "English", region: "US" },
    en_AU: { speechCode: "en-AU", translateCode: "en", displayName: "English", region: "AU" },
    en_CA: { speechCode: "en-CA", translateCode: "en", displayName: "English", region: "CA" },
    en_GB: { speechCode: "en-GB", translateCode: "en", displayName: "English", region: "GB" },
    es_ES: { speechCode: "es-ES", translateCode: "es", displayName: "Español", region: "ES" },
    es_MX: { speechCode: "es-MX", translateCode: "es", displayName: "Español", region: "MX" },
    fr_FR: { speechCode: "fr-FR", translateCode: "fr", displayName: "Français", region: "FR" },
    fr_CA: { speechCode: "fr-CA", translateCode: "fr", displayName: "Français", region: "CA" },
    de_DE: { speechCode: "de-DE", translateCode: "de", displayName: "Deutsch", region: "DE" },
    it_IT: { speechCode: "it-IT", translateCode: "it", displayName: "Italiano", region: "IT" },
    pt_BR: { speechCode: "pt-BR", translateCode: "pt", displayName: "Português", region: "BR" },
    pt_PT: { speechCode: "pt-PT", translateCode: "pt", displayName: "Português", region: "PT" },
    ja_JP: { speechCode: "ja-JP", translateCode: "ja", displayName: "日本語", region: "JP" },
    pl_PL: { speechCode: "pl-PL", translateCode: "pl", displayName: "Polski", region: "PL" },
    zh_CN: { speechCode: "zh-CN", translateCode: "zh-Hans", displayName: "中文", region: "CN" },
    gu_IN: { speechCode: "gu-IN", translateCode: "gu", displayName: "ગુજરાતી", region: "IN" },
};

// Deduplicated list for UI display (one entry per unique language)
export const TRANSLATION_LANGUAGE_OPTIONS = [
    { key: "en_US", speechCode: "en-US", translateCode: "en", displayName: "English" },
    { key: "es_ES", speechCode: "es-ES", translateCode: "es", displayName: "Español" },
    { key: "fr_FR", speechCode: "fr-FR", translateCode: "fr", displayName: "Français" },
    { key: "de_DE", speechCode: "de-DE", translateCode: "de", displayName: "Deutsch" },
    { key: "it_IT", speechCode: "it-IT", translateCode: "it", displayName: "Italiano" },
    { key: "pt_BR", speechCode: "pt-BR", translateCode: "pt", displayName: "Português" },
    { key: "ja_JP", speechCode: "ja-JP", translateCode: "ja", displayName: "日本語" },
    { key: "pl_PL", speechCode: "pl-PL", translateCode: "pl", displayName: "Polski" },
    { key: "zh_CN", speechCode: "zh-CN", translateCode: "zh-Hans", displayName: "中文" },
    { key: "gu_IN", speechCode: "gu-IN", translateCode: "gu", displayName: "ગુજરાતી (Gujarati)" },
];

// Azure TTS neural voice names for each target language (used for speech synthesis)
export const AZURE_TTS_VOICES = {
    en: { female: "en-US-JennyNeural", male: "en-US-GuyNeural" },
    es: { female: "es-ES-ElviraNeural", male: "es-ES-AlvaroNeural" },
    fr: { female: "fr-FR-DeniseNeural", male: "fr-FR-HenriNeural" },
    de: { female: "de-DE-KatjaNeural", male: "de-DE-ConradNeural" },
    it: { female: "it-IT-ElsaNeural", male: "it-IT-DiegoNeural" },
    pt: { female: "pt-BR-FranciscaNeural", male: "pt-BR-AntonioNeural" },
    ja: { female: "ja-JP-NanamiNeural", male: "ja-JP-KeitaNeural" },
    pl: { female: "pl-PL-AgnieszkaNeural", male: "pl-PL-MarekNeural" },
    "zh-Hans": { female: "zh-CN-XiaoxiaoNeural", male: "zh-CN-YunxiNeural" },
    gu: { female: "gu-IN-DhwaniNeural", male: "gu-IN-NiranjanNeural" },
};

// Voice type options
export const VOICE_TYPES = {
    FEMALE: "female",
    MALE: "male",
};

// Audio configuration for Web Audio API -> Azure SDK pipeline
export const AUDIO_CONFIG = {
    SAMPLE_RATE: 16000, // Azure expects 16kHz
    CHANNELS: 1, // Mono
    BITS_PER_SAMPLE: 16, // 16-bit PCM
    BUFFER_SIZE: 4096, // ScriptProcessorNode buffer size
    ORIGINAL_VOLUME_WHEN_TRANSLATING: 0, // Mute original audio when translation is active
};

// Translation feature lifecycle states
export const TRANSLATION_STATE = {
    IDLE: "idle",
    STARTING: "starting",
    ACTIVE: "active",
    ERROR: "error",
    STOPPING: "stopping",
};
